import { PayinCommonAppealV1TraderReason } from '~/generated/payinBackend/model';

export const appealReasons = [
    {
        value: PayinCommonAppealV1TraderReason.TRADER_REASON_MERCHANT_FRAUD,
        label: 'Мошенничество со стороны мерчанта',
    },
    {
        value: PayinCommonAppealV1TraderReason.TRADER_REASON_AMOUNT_MISMATCH,
        label: 'Несоответствие суммы',
    },
    {
        value: PayinCommonAppealV1TraderReason.TRADER_REASON_UNSPECIFIED,
        label: 'Другое',
    },
];
